import { render } from "./UserInvite.vue?vue&type=template&id=b2de955c"
import script from "./UserInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInvite.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/ss_user/components/UserInvite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2de955c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2de955c', __exports__)) {
    api.reload('b2de955c', __exports__)
  }
  
  module.hot.accept("./UserInvite.vue?vue&type=template&id=b2de955c", () => {
    api.rerender('b2de955c', render)
  })

}


export default __exports__